const emailTrackingDialog = require('./emailTracking-dialog')
const emailTrackingDt     = require('./emailTracking-dt')
const emailTrackingPage   = require('./emailTracking-page')

export function start(detail) {

      obj[detail.elem].start(detail)

}/**/

const obj = {

      dialog: { start: (detail) => { emailTrackingDialog.start(detail) } },
      dt:     { start: (detail) => { emailTrackingDt.start(detail)     } },
      page:   { start: (detail) => { emailTrackingPage.start(detail)   } },

}/**/
